import React from 'react'
import { useGLTF } from '@react-three/drei'

import { useLoader, useFrame  } from '@react-three/fiber'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import * as THREE from 'three'

import percyModel from '../resources/percy.glb';

export default function Model(props) {
    const gltf = useLoader(GLTFLoader, percyModel);
        // Here's the animation part
    // ************************* 
    let mixer
    if (gltf.animations.length) {
      mixer = new THREE.AnimationMixer(gltf.scene);
      gltf.animations.forEach(clip => {
        const action = mixer.clipAction(clip)
        action.play();
      });
    }

    useFrame((state, delta) => {
      mixer?.update(delta)
    })
    // *************************

    gltf.scene.traverse(child => {
      if (child.isMesh) {
        child.castShadow = true
        child.receiveShadow = true
        child.material.side = THREE.FrontSide
      }
    })
    return (
      <primitive
        object={gltf.scene} scale={props.size || 0.2} onClick={props.onClick} position={props.position || [0.1, 0.1, -0.1]} />
        // object={gltf.scene} scale={0.2} onClick={(e) => alert("click")} position={[1, 1, -1]} />
    );
}

useGLTF.preload(percyModel);
